export default "__VITE_ASSET__9fdb6b15__"